import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { selectIsAuth, selectUserRole } from '../reducers/userDataReducer'

const withRoleProtection = (
  Component,
  allowedRoles = ['Administrator'],
  redirectPath = '/dashboard/calendar',
) => {
  const ProtectedComponent = (props) => {
    const navigate = useNavigate()
    const auth = useSelector(selectIsAuth)
    const role = useSelector(selectUserRole)

    useEffect(() => {
      if (!auth) {
        navigate('/login')
      } else if (!allowedRoles.includes(role)) {
        navigate(redirectPath)
      }
    }, [auth, role, navigate])

    return <Component {...props} />
  }

  ProtectedComponent.propTypes = {
    auth: PropTypes.bool.isRequired,
    role: PropTypes.string.isRequired,
  }

  ProtectedComponent.displayName = `Protected${Component.name}`

  return ProtectedComponent
}

export default withRoleProtection
